import { FC } from "react";
import { Stack } from "@mui/material";
import { WidgetTotalsSummary } from "../../../../pages/dashboard/components/widgets/common/WidgetTotalsSummary";
import {
  DateDataPointNullable,
  Dates,
  GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiResponse,
  WidgetCostBreakdownAggregation,
  WidgetCostBreakdownVisualization,
} from "@/services/cloudchipr.api";
import { ForecastOption } from "@/services/cloudchipr-authless.api";
import { WidgetCosts } from "@/store/dashboards/utils/types/types";
import { BillingExplorerWidgetHighChart } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/billing-explorer/components/high-chart-view/BillingExplorerWidgetHighChart";

interface UnauthorizedBillingExplorerWidgetChartViewProps {
  loading: boolean;
  dates?: Dates;
  dateDataPoint: DateDataPointNullable;
  forecastOption?: ForecastOption;
  widgetData: GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiResponse;
  widgetCosts?: WidgetCosts;
  visualization: WidgetCostBreakdownVisualization;
  aggregation: WidgetCostBreakdownAggregation;
}

export const UnauthorizedBillingExplorerWidgetChartView: FC<
  UnauthorizedBillingExplorerWidgetChartViewProps
> = ({
  dateDataPoint,
  loading,
  dates,
  forecastOption,
  widgetData,
  widgetCosts,
  visualization,
  aggregation,
}) => {
  return (
    <Stack px={2} py={1} gap={1}>
      {dateDataPoint && forecastOption && widgetCosts && (
        <WidgetTotalsSummary
          frequency={dateDataPoint}
          costsData={widgetCosts}
          forecastOption={forecastOption}
          dateLabel={dates?.label}
          showTrends={visualization.trend}
          aggregations={aggregation}
        />
      )}

      <BillingExplorerWidgetHighChart
        dates={dates}
        loading={loading}
        data={widgetData.data}
        frequency={dateDataPoint}
        visualization={visualization}
        forecastedCosts={widgetData.forecasted_costs}
      />
    </Stack>
  );
};
